import { IProductSearch } from 'shared/types/ProductSearch';
import { IProduct } from 'shared/types/Product';
import { Update2022VariantDetail } from 'productTemplate/components/buyBar/VariantDetail/Update2022VariantDetail';
import { Update2022VariantDetailMobileView } from 'productTemplate/components/buyBar/VariantDetail/Update2022VariantDetailMobileView';

export type IVariantData = IProduct | IProductSearch;

export interface IVariantDetailProps {
  className?: string;
  isMobile: boolean;
  variantData: IVariantData;
}

export const VariantDetail = (props: IVariantDetailProps) => {
  const { isMobile } = props;

  return isMobile ? <Update2022VariantDetailMobileView /> : <Update2022VariantDetail {...props} />;
};
